import { LocatieVoorEenheden } from './LocatieVoorEenheden';

export enum DefectSoortcodeEnum {
  DEFECT_NIET_INZETBAAR = '1',
  BEPERKING_IN_TREINDIENST = '11',
  GEEN_BEPERKINGEN = '3',
}

// Used for explicit typing of the Defect soorcode in type specific types.
type DefectNietInzetbaarSoortCode = DefectSoortcodeEnum.DEFECT_NIET_INZETBAAR;
type DefectBeperkingInTreindienstSoortCode = DefectSoortcodeEnum.BEPERKING_IN_TREINDIENST;
type DefectGeenBeperkingenSoortCode = DefectSoortcodeEnum.GEEN_BEPERKINGEN;
export type BronType = 'HANDMATIG' | 'WERKORDER' | 'ASSETSTATUS';
// Used in Api for GET Type
export type DefectSoort = 'GEEN_BEPERKINGEN' | 'DEFECT_NIET_INZETBAAR' | 'BEPERKING_IN_TREINDIENST';
export type DefectStatus = 'OPENSTAAND' | 'GEREED_GEMELD';

export enum DefectSoortcodeLabelEnum {
  DEFECT_NIET_INZETBAAR = 'Defect niet inzetbaar',
  BEPERKING_IN_TREINDIENST = 'Beperking in treindienst',
  GEEN_BEPERKINGEN = 'Geen beperkingen',
}

type DefectBaseType = {
  eenheidnummer?: string;
  begindatumtijd?: string;
};

export type DefectFormType = DefectBaseType & {
  soortcode: DefectNietInzetbaarSoortCode | DefectBeperkingInTreindienstSoortCode | DefectGeenBeperkingenSoortCode;
  toelichting?: string;
};

export type Defect = {
  id: number;
  werkorderId: string | null;
  soort: DefectSoort;
  werkplaats: string | null;
  eenheidNummer: string;
  beginTijd: string | null;
  eindTijd: string | null;
  nietMeerInzetbaarVanaf: string | null;
  toelichting: string;
  bron: BronType;
  verplaatsingsBeperking: boolean;
  gereedgemeld: boolean;
  materieelSoort: string;
  werklijnId?: string | null;
  beginDrglpt?: string;
  drglptMetTijdList?: DrglptMetTijd[];
  prioriteitscore?: number;
  /** Plank/LMM attributen */
  verwachtGereed?: string | null;
  huidigeLocatie?: LocatieVoorEenheden;
  snelheidBeperking?: string | null;
  rijBeperking?: string | null;
  standaardSnelheid?: number;
};

export type DrglptMetTijd = {
  aankomstDienstregelpunt: string;
  vertrekTijd: string;
};

export type MaakDefectNietInzetBaarFormType = {
  eenheidnummer: HTMLInputElement;
  begindatumtijd: HTMLInputElement;
  soortcode: HTMLInputElement;
};

export const getDefectSoort = (defect: Defect) => {
  return defect.gereedgemeld ? 'GEREED_GEMELD' : 'OPENSTAAND';
};

export const getDefectBron = (defect: Defect) => {
  return defect.bron === 'HANDMATIG' ? 'HANDMATIG' : undefined;
};
